// France and Belgium are not available values yet for api payload
export enum ShortRegionCode {
    DEU = 'DEU',
    AUS = 'AUS',
    SWT = 'SWT',
    BEL = 'BEL',
}

// StartedSelling and NoSaleProject are not available values yet for api payload
export enum TimeToSell {
    ASAP = 'ASAP',
    NextThreeMonth = 'NEXT_THREE_MONTH',
    NextSixMonth = 'NEXT_SIX_MONTH',
    NextTwelveMonth = 'NEXT_TWELVE_MONTH',
    Later = 'LATER',
}
